import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconAccess({
  fill = 'var(--sapphire-20)',
  width = 24,
  height = 24,
}: SvgTypesProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.00006 12.0003L7.50006 8.0003C7.22392 5.79116 8.79092 3.77645 11.0001 3.5003C13.2092 3.22416 15.2239 4.79116 15.5001 7.0003L15.7501 9.0003M12 15.0003V17.5003M7 20.0003H17C17.5523 20.0003 18 19.5526 18 19.0003V13.0003C18 12.448 17.5523 12.0003 17 12.0003H7C6.44772 12.0003 6 12.448 6 13.0003V19.0003C6 19.5526 6.44772 20.0003 7 20.0003Z" stroke={fill} strokeWidth="1.5"/>
      <circle cx="12" cy="15" r="1.25" fill={fill}/>
    </svg>
  );
}
